import {TYPE_MATRIX_AXIS_OPTIONS} from "../../Constants"

export type MatrixAxisOptionDtoAttributes = {
    name: string
    orderBy: number
    axisType: string
    matrixID: string
}

export type MatrixAxisOptionDto = {
    id: string
    type: string
    attributes: MatrixAxisOptionDtoAttributes
}

const initialMatrixAxisOptionAttributes: MatrixAxisOptionDtoAttributes = {
    name: "",
    orderBy: -1,
    axisType: "",
    matrixID: "",
}

export const initialMatrixAxisOption: MatrixAxisOptionDto = {
    id: "",
    type: TYPE_MATRIX_AXIS_OPTIONS,
    attributes: initialMatrixAxisOptionAttributes,
}


// WEBPACK FOOTER //
// ./src/state/product/matrix/matrix-axis-option/MatrixAxisOption.ts